var icms = icms || {};

icms.pointerpro = (function ($) {

    this.loader = $('#js_overlay_loader');

    this.stopped = [];

    this.onDocumentReady = function() {

        // $('.services-list__item').on('click', '.f_title', function () {
        //     var TITLE = $(this),
        //         ITEM = TITLE.closest('.services-list__item'),
        //         DESC = ITEM.find('.fields');
        //
        //     DESC.slideToggle();
        // });
        //
        // $('#modal_26').on('show.bs.modal', function (event) {
        //     var button  = $(event.relatedTarget),
        //         product = button.data('product'),
        //         productURI = button.data('product-uri'),
        //         modal = $(this);
        //     modal.find('input[name=product]').val(product);
        //     modal.find('input[name=product_uri]').val(productURI);
        // });

        // $('input[type=tel]').mask("+7 (999) 999-99-99");

        // // раскрытие фильтра товаров в мобильной версии
        // $(document).on('click', '.js-filter-title', function () {
        //     $(this).parent().toggleClass('opened');
        // });

        // $(document).on('click', '.js-scroll-to', function (e) {
        //     e.preventDefault();
        //
        //     var THIS = $(this),
        //         target = $(THIS.data('target')),
        //         target_offset = target.offset();
        //
        //     $("html, body").animate({scrollTop: target_offset.top}, 300);
        //     target.focus();
        //
        // });

        // $('#slider-front').slick({
        //     dots: true,
        //     customPaging: function(slider, i) {
        //         return $('<span></span>');
        //     },
        //     appendDots: '#slider-top__dots',
        //     arrows: false,
        //     // prevArrow: '<div class="slick-control slick-prev"><svg><use xlink:href="/templates/itp/svg/sprite.svg#left-arrow" /></svg></div>',
        //     // nextArrow: '<div class="slick-control slick-next"><svg><use xlink:href="/templates/itp/svg/sprite.svg#left-arrow" /></svg></div>',
        //     autoplay: false,
        //     autoplaySpeed: 6000,
        //     pauseOnHover: false
        // });

        // $('#slider-main').slick({
        //     dots: true,
        //     customPaging: function(slider, i) {
        //         return $('<span></span>');
        //     },
        //     arrows: true,
        //     prevArrow: '<div class="slick-control slick-prev fontello-right-arrow"></div>',
        //     nextArrow: '<div class="slick-control slick-next fontello-right-arrow"></div>',
        //     autoplay: true,
        //     autoplaySpeed: 6000,
        //     pauseOnHover: false
        // });

        // $('#clients-carousel').slick({
        //     slidesToShow: 5,
        //     slidesToScroll: 1,
        //     dots: false,
        //     arrows: true,
        //     prevArrow: '<div class="slick-control slick-prev fontello-double-angle-right"></div>',
        //     nextArrow: '<div class="slick-control slick-next fontello-double-angle-right"></div>',
        //     // prevArrow: '#clients-carousel__prev',
        //     // nextArrow: '#clients-carousel__next',
        //     autoplay: false,
        //     speed: 300,
        //     autoplaySpeed: 3000,
        //     pauseOnHover: false,
        //     responsive: [
        //         {
        //             breakpoint: 1200,
        //             settings: {
        //                 slidesToShow: 4
        //             }
        //         },
        //         {
        //             breakpoint: 992,
        //             settings: {
        //                 slidesToShow: 3
        //             }
        //         },
        //         {
        //             breakpoint: 768,
        //             settings: {
        //                 slidesToShow: 3
        //             }
        //         },
        //         {
        //             breakpoint: 576,
        //             settings: {
        //                 slidesToShow: 1
        //             }
        //         }
        //     ]
        // });

        // инициализируем кнопки копирования в буфер обмена
        if ( ClipboardJS.isSupported() ) {
            var clipboard = new ClipboardJS('.js-btn-clipboard');

            clipboard.on('success', function(e) {
                $(e.trigger).css('width', $(e.trigger).innerWidth());
                $(e.trigger).text( $(e.trigger).data('after-text') );
                $(e.trigger).addClass('copied');

                e.clearSelection();

                setTimeout( function () {
                    $(e.trigger).text( $(e.trigger).data('original-text') );
                    $(e.trigger).removeClass('copied').blur();
                }, 3000 );
            });
        } else {
            $('.js-btn-clipboard').hide();
        }

        if ( ClipboardJS.isSupported() ) {
            var promocode = new ClipboardJS('.js-promocode-clipboard');

            promocode.on('success', function(e) {
                $('.js-text', e.trigger).text( $(e.trigger).data('after-text') );
                $(e.trigger).addClass('copied');

                e.clearSelection();

                setTimeout( function () {
                    $('.js-text', e.trigger).text( $(e.trigger).data('original-text') );
                    $(e.trigger).removeClass('copied').blur();
                }, 3000 );
            });
        }

        $(document).on('click', 'button[aria-controls=navbarMain]', function (e) {
            $(this).closest('nav.navbar').toggleClass('navbar-opened')
        });

        // $('.navbar-default').on('click', '.ajax-modal a', function (e) {
        //     $('#main-nav').collapse('hide');
        // });

        //$('.navbar-default').on('click', 'li.dropdown > a', function (e) {
        //    if ( $(window).width() >= 768 ) {
        //        window.location.href = $(this).attr('href');
        //    }
        //});

        // чтобы успевали загрузиться все изображения,
        // чтобы правильно рассчитывались размеры,
        // иначе при первичной загрузке страницы баннеры фиксируются с ошибкой
        // отключил, переделал на css position: sticky
        // $(window).on("load", function () {
        //
        //     right_banners_fixing();
        //
        //     $(window).on('resize', function() {
        //         right_banners_fixing();
        //     });
        //
        //     $(window).on('scroll', function() {
        //         right_banners_fixing();
        //     });
        //
        // });

        $('body').on('click', '.js_show_more_content', function (e) {
            e.preventDefault();

            var btn = $(this),
                targetUrl = btn.attr('href');

            // var spinner = btn.find('.spin');
            // spinner.addClass('animate');

            icms.pointerpro.loader.show();

            $.ajax({
                type: 'get',
                url: targetUrl,
                // headers: {"X-Requested-With": "NULL"},
                success: function (data) {

                    var list = $('.js_list_items_wrap'),
                        showMore = $('#js_show_more_wrap'),
                        content = $($.parseHTML('<div>'+data+'</div>')),
                        items = content.find('.js_list_item'),
                        more = content.find('#js_show_more_wrap');

                    list.append(items); // добавляем элементы в список

                    showMore.replaceWith(more); // обновляем кнопку показать еще
                },
                complete: function () {
                    // spinner.removeClass('animate');
                    icms.pointerpro.loader.hide();
                    history.pushState('', '', targetUrl);
                }
            });

        });

        // $(document).on('submit', '.js-sity-search-form', function (e) {
        //     e.preventDefault();
        // });
        //
        // $(document).on('keyup', '.js_smart_search_input', function (e){
        //     var INPUT = $(this),
        //         STRING = INPUT.val();
        //     if (STRING.length > 1) { // делаем запрос, если длина строки больше 2 символов
        //
        //         if (typeof timeout_id !== "undefined") { //timeout_clear();
        //             clearTimeout(timeout_id);
        //         }
        //
        //         timeout_id = setTimeout(function(){
        //             searchGetResults(INPUT,STRING);
        //         }, 200); //timeout_set();
        //
        //     }
        //     if (STRING.length === 0) {
        //
        //         INPUT.parent().next().children.html('').hide();
        //
        //     }
        // });

        // function searchGetResults(INPUT,STRING){
        //     console.log('searchGetResults');
        //     console.log('');
        //
        //     STRING = STRING.replace(/ /gi, '+')
        //
        //     var RESULTBLOCK = INPUT.parent().next(),
        //         CTYPE_NAME = INPUT.attr('data-ctype-name'),
        //         loader = $('#js_overlay_loader');
        //
        //     loader.show();
        //     $.ajax({
        //         type: 'get',
        //         dataType: 'json',
        //         headers: {"X-Requested-With": "NULL"},
        //         url: '/'+CTYPE_NAME+'/get_categories?search_string='+STRING,
        //         success: function (data) {
        //             console.log(data);
        //             if(data.success) {
        //                 $('.smart-result_inner', RESULTBLOCK).empty();
        //                 $('.smart-result_inner', RESULTBLOCK).append(data.html);
        //             } else {
        //                 $('.smart-result_inner', RESULTBLOCK).html('Город не найден')
        //             }
        //             RESULTBLOCK.show();
        //         },
        //         complete: function () {
        //             loader.hide();
        //
        //             $(document).mouseup(function (e){
        //                 if (!RESULTBLOCK.is(e.target) // если клик был не по нашему блоку
        //                     && RESULTBLOCK.has(e.target).length === 0) { // и не по его дочерним элементам
        //                     RESULTBLOCK.hide(); // скрываем его
        //                 }
        //             });
        //         }
        //     });
        //
        //     return true;
        // }

        // setInterval(function(){
        //     icms.pointerpro.getUserNotices();
        // }, 5 * 60 * 1000);

    };

    // this.getUserNotices = function () {
    //
    //     var last_main_event_id = $.cookie('icms[last_main_event_id]');
    //
    //     $.ajax({
    //         type: 'GET',
    //         url: '/prognozy_na_sport/get_last_main_event_id',
    //         dataType: 'json'
    //     }).done(function(data) {
    //         if ( data.success ) {
    //
    //             if( !last_main_event_id || (last_main_event_id != data.item.id) ){
    //
    //                 $.cookie('icms[last_main_event_id]', data.item.id, {expires: 365, path: '/'});
    //
    //                 if(Notification) {
    //                     //console.log(data);
    //                     var instance = Notification.requestPermission(function (permission){
    //                         if(permission !== 'granted') { return false; }
    //
    //                         notification = new Notification('BetAdvise. Новый прогноз!', {
    //                             lang: 'ru-RU',
    //                             tag: "BetAdvise",
    //                             body: data.text,
    //                             icon: "/templates/itp/images/logo_icon.png"
    //                         });
    //
    //                         notification.onclick = function(){
    //                             window.location.href = data.link;
    //                         };
    //
    //                     });
    //                 }
    //             }
    //
    //         } else {
    //             console.log(data);
    //         }
    //
    //     });
    //
    // };


    return this;

}).call(icms.pointerpro || {},jQuery);

window.onload = function () {
    jQuery('.preloader:not(".loaded")').addClass('loaded');
    jQuery('.overhid').removeClass('overhid');
};
